<template>
    <div class="hero" id="hero">
        <div class="jumbotron jumbotron-fluid d-flex justify-content-center">
            <div class="container hero-title text-center text-white py-5">
                <h1 class="display-4" data-aos="zoom-in" data-aos-duration="1200">Muhammad Valensyah Alfansyuri</h1>
                <p class="lead" data-aos="zoom-in" data-aos-duration="1200" data-aos-delay="300">Hi! It's nice to meet you. I hope you have a good day</p>
                <p class="lead-2" data-aos="zoom-in" data-aos-duration="1200" data-aos-delay="400">This Website Created Using Vue.js</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Hero'
}
</script>

<style lang="scss" scoped>
.hero {
    height: 300px;
    width: 100%;
    &-title {
        margin: 2% 0%;
        width: inherit;
        h1, p {
            text-shadow: 2px 2px 3px darkgray;
        }
        lead-2 {
            font-size: 0.75rem;
        }
    }
    .jumbotron {
        height: 100%;
        background-image: linear-gradient(120deg, #89f7fe 0%, #66a6ff 100%);
    }

}
</style>
